import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from '../../components/authProvider/AuthContext';
import { selectError } from '../../redux-state/selectors';
import PrimaryButton from '../../components/common/button/PrimaryButton';

function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const error = useSelector(selectError);

  useEffect (() => {
    if(isLoggedIn()) {
      navigate('/dashboard')
    }
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');
    dispatch({ type: 'CLEAR_MFA_ERROR' });

    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    localStorage.setItem('email', email);
    forgetPassword();
  };


  const backToLogin = () => {
    dispatch({ type: 'CLEAR_MFA_ERROR' });
    navigate('/login')
  }

  const forgetPassword = () => {
    return dispatch({
      type: 'FORGET_PASSWORD',
      payload: {username: email},
      navigate: navigate,
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 items-center justify-center p-4 gap-64">
      <form className="bg-white rounded-2xl shadow-md p-10 max-w-[500px] mt-32" onSubmit={handleSubmit}>
        <div className="text-center mb-10">
          <div className="flex items-center justify-center mb-10">
            <div className="w-16 h-14 rounded-full flex items-center justify-center">
              <img className="h-16 w-16 max-w-none" src="/logo.png" alt="" style={{ width: "100px", height: "100px" }}/>
            </div>
          </div>

          <div className="text-2xl font-bold text-gray-700 mb-2">
            Forgot Password
          </div>

          <div className="text-gray-500 text">
            To reset your password, we will securely send a verification code to your registered email address.
          </div>
          {error && (
            <p className="text-sm text-red-500 mt-2 text-center">{error}</p>
          )}
        </div>

        <div className="mb-6">
          <TextField
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full"
            id="outlined-basic"
            label="Enter Email"
            variant="outlined"
            error={!!emailError}
            helperText={emailError}
            InputProps={{ className: 'boarder-radius-10' }}
          />
        </div>

        <PrimaryButton
          text="Send verification code"
          type="submit"
          className="w-full"
        />

        {/*
          type="button" for the same reason as the login form: without it this
          defaults to type="submit", so clicking "Back to Login" also submitted the
          form and dispatched FORGET_PASSWORD -- firing a password-reset email the
          user never asked for on the way back to the login page.
        */}
        <div className="text-center mt-8">
          <button type="button" className="text-gray-600 text-sm hover:text-gray-800 hover:underline transition-colors" onClick={backToLogin}>
            Back to Login
          </button>
        </div>
      </form>

      <div className='w-full max-w-[30%] justify-self-end'>
        <div className="flex flex-row w-full justify-between">
          <div>Privacy policy </div>
          <div>Copyright 2025</div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
